import { containerOrientations } from './container-dir';
import { containerSpacingModes } from './container-spacing-modes';
//
// Alignment booleans
//
// Alignments allow a number of incoming setting variations to make the component easier to use.
// Here we condense down to a smaller set of booleans for sake of our CSS below.
// Generally, the top, right, bottom, and left also account for a `-center` or `center-` variant,
// whereas the compound options in the corners are preserved.
// However, when `spaceBetween` is used, these corner edge cases are flattened appropriately
// along with any redundant settings.
// For example:
//   - when `spaceBetween` and `horizontal`, 'top-left' is converted to just `top`.
//   - when `spaceBetween` and `horizontal`, 'left' is converted to just `center`.
// Default `align` is `left` or `top` depending on `dir`, and `spacingMode`.
//
export const containerAlignment = (align, dir, spacingMode) => {
    const { horizontal, vertical } = containerOrientations(dir);
    const { packed, spaceBetween } = containerSpacingModes(spacingMode);
    //
    // Debugging aid; please leave in place
    //
    // console.log('utils: containerAlignment');
    // console.table([
    //   {
    //     label: 'align',
    //     value: align,
    //   },
    //   {
    //     label: 'dir',
    //     value: dir,
    //   },
    //   {
    //     label: 'spacing',
    //     value: spacingMode,
    //   },
    // ]);
    return {
        bottom: (() => {
            // Standard cases
            if (align === 'bottom' || align === 'bottom-center') {
                return true;
            }
            // Edge cases
            if (spaceBetween && horizontal) {
                return align === 'bottom-left' || align === 'bottom-right';
            }
            return false;
        })(),
        bottomLeft: align === 'bottom-left',
        bottomRight: align === 'bottom-right',
        center: (() => {
            // Standard case
            if (align === 'center') {
                return true;
            }
            // Default when spaceBetween, horizontal, and no align provided
            if (spaceBetween && horizontal && !align) {
                return true;
            }
            // Edge cases
            if (spaceBetween && vertical) {
                return (!align ||
                    align === 'top' ||
                    align === 'bottom' ||
                    align === 'top-center' ||
                    align === 'bottom-center');
            }
            if (spaceBetween && align && horizontal) {
                return (align === 'left' ||
                    align === 'center-left' ||
                    align === 'right' ||
                    align === 'center-right');
            }
            return false;
        })(),
        left: (() => {
            // Standard cases
            if (align === 'left' || align === 'center-left') {
                return true;
            }
            // Default when packed, horizontal, and no align provided
            if (packed && horizontal && !align) {
                return true;
            }
            // Edge cases
            if (spaceBetween && vertical) {
                return align === 'top-left' || align === 'bottom-left';
            }
            return false;
        })(),
        right: (() => {
            // Standard cases
            if (align === 'right' || align === 'center-right') {
                return true;
            }
            // Edge cases
            if (spaceBetween && vertical) {
                return align === 'top-right' || align === 'bottom-right';
            }
            return false;
        })(),
        top: (() => {
            // Standard cases
            if (align === 'top' || align === 'top-center') {
                return true;
            }
            // Default when packed, vertical, and no align provided
            if (packed && vertical && !align) {
                return true;
            }
            // Edge cases
            if (spaceBetween && horizontal) {
                return align === 'top-left' || align === 'top-right';
            }
            return false;
        })(),
        topLeft: align === 'top-left',
        topRight: align === 'top-right',
    };
};
